<style lang="less">
  @import "./Unbound.less";
</style>

<template>
  <div class="unbound">
    <van-cell-group>
      <!--<van-cell title="IMEI" icon="setting-o" :value="nowImei" is-link @click="toChangeDevPageFn" />-->
      <van-cell title="IMEI" icon="setting-o" :value="nowImei" />
    </van-cell-group>
    <div class="page-btn">
      <van-button type="info" size="large" @click="wxUnboundFn">设备解绑</van-button>
    </div>
  </div>
</template>

<script>
import Unbound from './Unbound.js'
export default {
  ...Unbound
}
</script>
